/**
 * @generated SignedSource<<f31ab28cee35491a9307270ef32616eb>>
 * @relayHash 653e4292ed116dfebafab4695c5e8d48
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6b88a0aac50f0af09e01d6b78e1088bcf047a8a828512b078466d7fc9ac20432

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraFieldOptionIdsFilterOperation = "ALLOW" | "EXCLUDE" | "%future added value";
export type JiraFieldOptionIdsFilterInput = {
  operation: JiraFieldOptionIdsFilterOperation;
  optionIds: ReadonlyArray<string>;
};
export type resolutionQuery$variables = {
  ari: string;
  filterById?: JiraFieldOptionIdsFilterInput | null | undefined;
  isResolutionForTransition: boolean;
  transitionId: string;
};
export type resolutionQuery$data = {
  readonly node: {
    readonly resolutions?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly label: string | null | undefined;
          readonly value: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly resolutionsForTransition?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly label: string | null | undefined;
          readonly value: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type resolutionQuery = {
  response: resolutionQuery$data;
  variables: resolutionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ari"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterById"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isResolutionForTransition"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "transitionId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "ari"
  }
],
v5 = {
  "kind": "Variable",
  "name": "filterById",
  "variableName": "filterById"
},
v6 = [
  (v5/*: any*/)
],
v7 = {
  "alias": "value",
  "kind": "ScalarField",
  "name": "id"
},
v8 = {
  "alias": "label",
  "kind": "ScalarField",
  "name": "name"
},
v9 = [
  {
    "concreteType": "JiraResolutionEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "JiraResolution",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v8/*: any*/)
        ]
      }
    ]
  }
],
v10 = [
  (v5/*: any*/),
  {
    "kind": "Variable",
    "name": "transitionId",
    "variableName": "transitionId"
  }
],
v11 = {
  "kind": "ScalarField",
  "name": "id"
},
v12 = [
  {
    "concreteType": "JiraResolutionEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "JiraResolution",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v8/*: any*/),
          (v11/*: any*/)
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "resolutionQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "condition": "isResolutionForTransition",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                  {
                    "args": (v6/*: any*/),
                    "concreteType": "JiraResolutionConnection",
                    "kind": "LinkedField",
                    "name": "resolutions",
                    "plural": false,
                    "selections": (v9/*: any*/)
                  }
                ]
              },
              {
                "condition": "isResolutionForTransition",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "args": (v10/*: any*/),
                    "concreteType": "JiraResolutionConnection",
                    "kind": "LinkedField",
                    "name": "resolutionsForTransition",
                    "plural": false,
                    "selections": (v9/*: any*/)
                  }
                ]
              }
            ],
            "type": "JiraResolutionField"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "resolutionQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "condition": "isResolutionForTransition",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                  {
                    "args": (v6/*: any*/),
                    "concreteType": "JiraResolutionConnection",
                    "kind": "LinkedField",
                    "name": "resolutions",
                    "plural": false,
                    "selections": (v12/*: any*/)
                  }
                ]
              },
              {
                "condition": "isResolutionForTransition",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "args": (v10/*: any*/),
                    "concreteType": "JiraResolutionConnection",
                    "kind": "LinkedField",
                    "name": "resolutionsForTransition",
                    "plural": false,
                    "selections": (v12/*: any*/)
                  }
                ]
              }
            ],
            "type": "JiraResolutionField"
          },
          (v11/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "6b88a0aac50f0af09e01d6b78e1088bcf047a8a828512b078466d7fc9ac20432",
    "metadata": {},
    "name": "resolutionQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e886abcbca64bda05f694b3d6df280e9";

export default node;
